import React from 'react';
import { TweenLite } from 'gsap';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';
import ScrollMagic from '../../plugins/ScrollMagic';

export default {

    initialise() {
        let controller = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            offset: '1000px',
            reverse: true
        })
            .setTween(TweenLite.fromTo(document.getElementById('back-to-top'), 0.25, {height: 0}, {height: '50px'}))
            .addTo(controller);

        return controller;
    },

    destroy(controller) {
        controller.destroy(true);
    },

    backToTop() {
        TweenLite.to(window, 0.5, {scrollTo: 0});
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/layout/BackToTop/animations.js